/* eslint-disable react/no-set-state,react/no-string-refs  */
import React from 'react';

class Tooltip extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            content,
            closeTooltip,
            visible,
            position
        } = this.props;

        // if (!visible) {
        //     return null;
        // }

        return (
            <div
                data-tooltip
                className={`tooltip ${position} ${visible ? 'tooltip--show' : ''}`}>
                <button className="tooltip-close" onClick={closeTooltip} />
                <div className="tooltip-content">
                    {content}
                </div>
            </div>
        )
    }
}

export default Tooltip;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/tooltip/tooltip.jsx